import { render, staticRenderFns } from "./OsInputTextArea.vue?vue&type=template&id=165605fa&scoped=true"
import script from "./OsInputTextArea.vue?vue&type=script&lang=ts"
export * from "./OsInputTextArea.vue?vue&type=script&lang=ts"
import style0 from "./OsInputTextArea.vue?vue&type=style&index=0&id=165605fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165605fa",
  null
  
)

export default component.exports